import { render, staticRenderFns } from "./e-button-burger.vue?vue&type=template&id=04948eec&scoped=true&lang=pug"
import script from "./e-button-burger.vue?vue&type=script&lang=js"
export * from "./e-button-burger.vue?vue&type=script&lang=js"
import style0 from "./e-button-burger.vue?vue&type=style&index=0&id=04948eec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04948eec",
  null
  
)

export default component.exports